import { useImage } from "../hooks/useImage";
export const ImageThumbnail = (props) => {
    const image = useImage(props.imageId);
    return image?.source_url ?(
         <img 
         style={{
            width:'100%',
            height:props.height ||'150px',
            objectfit:'cover',
            display:'block'}} 
         src={image.source_url} 
         alt={image.alt_text ?? image.title.rendered} 
         onClick={props.onClick}
         className={props.className || 'imgthumbnail'}
         />
    ):null;
}
